var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-c-type-date"},[_c('div',{staticClass:"c-panel-tabView-title"},[_vm._v("日期类型")]),_vm._v(" "),_c('div',[_c('el-radio',{attrs:{"label":"1","disabled":""},model:{value:(_vm.radio),callback:function ($$v) {_vm.radio=$$v},expression:"radio"}},[_vm._v("单日期：年-月-日")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff24b012","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cashier/components/cashierdiaryTable/dialogComponents/add-c-type-date.vue
// module id = null
// module chunks = 